import React, { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { Input, Select, Checkbox, Textarea } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import { sex, docTypes } from '../../../assets/const'
import { StudentsContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const typeInformationPercept = [
  { value: 1, name: 'Аудиал' },
  { value: 2, name: 'Визуал' },
  { value: 3, name: 'Кинестетик' },
  { value: 4, name: 'Дискрет' },
  { value: '', name: 'Не выбрано' }
]

export default function Main() {

  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)
  const { countries, subjects } = useSelector(state => state.common)

  const { values, setFieldValue, setValues } = allForms

  const { main } = studentTabData || {}

  // Ref для отслеживания последних загруженных данных
  const lastSyncedMainRef = useRef(null)

  // Кастомный handleChange для вложенных полей
  const handleMainChange = (e) => {
    const { name, value, type, checked } = e.target
    setFieldValue(`main.${name}`, type === 'checkbox' ? checked : value)
  }

  const renderOptions = ({ name, value, xp_key, subject, idschool, schoolname, idcountry, idsubject }) => (
    <option key={value || xp_key || idschool || idcountry || idsubject} value={value || xp_key || idschool || idcountry || idsubject}>
      {name || subject || schoolname}
    </option>
  )

  // Синхронизация формы с данными из API
  useEffect(() => {
    const mainJson = JSON.stringify(main)
    if (!addMode && main && lastSyncedMainRef.current !== mainJson) {
      lastSyncedMainRef.current = mainJson
      setValues(prev => ({
        ...prev,
        main: { ...main }
      }))
      // Сохраняем начальные значения для отслеживания изменений
      if (updateInitialValues) {
        updateInitialValues('main', main)
      }
    }
  }, [main, addMode, setValues, updateInitialValues])

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '220px' }}
            label='Фамилия'
            name='lastname'
            value={(values.main || {}).lastname || ''}
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '220px' }}
            label='Имя'
            name='firstname'
            value={(values.main || {}).firstname || ''}
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '220px' }}
            label='Отчество'
            name='patronymic'
            value={(values.main || {}).patronymic || ''}
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '150px' }}
            label='Номер'
            highlight
            name='number'
            value={(values.main || {}).number || ''}
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Логин'
            name='login'
            value={(values.main || {}).login || ''}
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '100px' }}
            label='Литер'
            highlight
            name='liter'
            value={(values.main || {}).liter || ''}
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '200px' }}
            label='Логин родителей'
            name='login_parent'
            value={(values.main || {}).login_parent || ''}
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Select
            style={{ width: '150px' }}
            label='Пол'
            highlight
            value={(values.main || {}).sex || ''}
            name='sex'
            onChange={handleMainChange}
          >
            {sex.map(renderOptions)}
          </Select>
          <Input
            style={{ width: '150px' }}
            label='Дата рождения'
            highlight
            type='date'
            value={(values.main || {}).birthday || ''}
            name='birthday'
            onChange={handleMainChange}
          />
          <Checkbox
            label='Годен к строевой службе'
            name='warready'
            checked={(values.main || {}).warready || false}
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '100%' }}
            label='Место рождения'
            highlight
            value={(values.main || {}).birthplace || ''}
            name='birthplace'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Select
            style={{ width: '340px' }}
            value={(values.main || {}).residingcountry_id || ''}
            name='residingcountry_id'
            label='Страна'
            onChange={handleMainChange}
          >
            {countries?.map(renderOptions)}
          </Select>
          <Select
            style={{ width: '340px' }}
            value={(values.main || {}).citizen_id || ''}
            name='citizen_id'
            label='Гражданство'
            onChange={handleMainChange}
          >
            {countries?.map(renderOptions)}
          </Select>
        </div>
        <div className={styles.inputsRow}>
          <Select
            style={{ width: '340px' }}
            label='Субъект РФ'
            name='residingsubject_id'
            value={(values.main || {}).residingsubject_id || ''}
            onChange={handleMainChange}
          >
            {subjects?.map(renderOptions)}
          </Select>
          <div style={{ minWidth: '20px' }}></div>
          <Input
            style={{ width: '120px' }}
            label='Индекс'
            value={(values.main || {}).residingindex || ''}
            name='residingindex'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '220px' }}
            label='Нас. пункт'
            value={(values.main || {}).residingtown || ''}
            name='residingtown'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '100%' }}
            label='Адрес проживания'
            highlight
            value={(values.main || {}).residingaddress || ''}
            name='residingaddress'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '180px' }}
            label='Дом. телефон'
            value={(values.main || {}).phone_home || ''}
            name='phone_home'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '180px' }}
            label='Моб. телефон'
            value={(values.main || {}).phone_cell || ''}
            name='phone_cell'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '180px' }}
            label='IMEI'
            value={(values.main || {}).phonecellimei || ''}
            name='phonecellimei'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '200px' }}
            label='Оператор сотовой связи'
            value={(values.main || {}).phonecelloperator || ''}
            name='phonecelloperator'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '200px' }}
            label='Модель телефона'
            value={(values.main || {}).phonecellmodel || ''}
            name='phonecellmodel'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '220px' }}
            label='E-mail'
            value={(values.main || {}).email || ''}
            name='email'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '220px' }}
            label='E-mail родителей'
            value={(values.main || {}).email_parent || ''}
            name='email_parent'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '180px' }}
            label='Skype'
            value={(values.main || {}).skype || ''}
            name='skype'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Регистрационные данные</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '100%' }}
            label='Адрес регистрации'
            highlight
            value={(values.main || {}).registrationaddress || ''}
            name='registrationaddress'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Select
            style={{ width: '200px' }}
            label='Тип документа'
            name='documenttype'
            value={(values.main || {}).documenttype || ''}
            onChange={handleMainChange}
          >
            {docTypes.map(renderOptions)}
          </Select>
          <Input
            style={{ width: '100px' }}
            label='Серия'
            value={(values.main || {}).documentseria || ''}
            name='documentseria'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Номер'
            value={(values.main || {}).documentnumber || ''}
            name='documentnumber'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Когда выдан'
            type='date'
            value={(values.main || {}).documentwhengive || ''}
            name='documentwhengive'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Textarea
            label='Кем выдан'
            style={{ width: '100%' }}
            value={(values.main || {}).documentwhogive || ''}
            name='documentwhogive'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Прочее</h3>
        <div className={styles.inputsRow}>
          <Select
            style={{ width: '250px' }}
            label='Тип восприятия информации'
            value={(values.main || {}).typeinformationpercept ?? ''}
            name='typeinformationpercept'
            onChange={handleMainChange}
          >
            {typeInformationPercept.map(renderOptions)}
          </Select>
          <Input
            style={{ width: '180px' }}
            label='S/N ноутбука'
            highlight
            value={(values.main || {}).notebooknumber || ''}
            name='notebooknumber'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '180px' }}
            label='Инв. № ноутбука'
            value={(values.main || {}).notebooknumber2 || ''}
            name='notebooknumber2'
            onChange={handleMainChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '200px' }}
            label='№ удостоверения учащегося'
            value={(values.main || {}).certificatenumber || ''}
            name='certificatenumber'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '200px' }}
            label='RFID метка'
            value={(values.main || {}).rfidid || ''}
            name='rfidid'
            onChange={handleMainChange}
          />
          <Button>Получить со считывателя</Button>
          <Button>Печать</Button>
        </div>
        <div className={styles.inputsRow}>
          <Textarea
            label='Примечание'
            style={{ width: '100%' }}
            value={(values.main || {}).comments || ''}
            name='comments'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Аттестат об основном общем образовании (9 класс)</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '180px' }}
            label='№ аттестата'
            value={(values.main || {}).attestat_9_number || ''}
            name='attestat_9_number'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Дата выдачи'
            type='date'
            value={(values.main || {}).attestat_9_issue_date || ''}
            name='attestat_9_issue_date'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='№ приказа'
            value={(values.main || {}).attestat_9_prikaz || ''}
            name='attestat_9_prikaz'
            onChange={handleMainChange}
          />
          <span className={styles.labelText}>от</span>
          <Input
            style={{ width: '150px' }}
            type='date'
            value={(values.main || {}).attestat_9_prikaz_date || ''}
            name='attestat_9_prikaz_date'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Аттестат о среднем общем образовании (11 класс)</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '180px' }}
            label='№ аттестата'
            value={(values.main || {}).attestat_11_number || ''}
            name='attestat_11_number'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Дата выдачи'
            type='date'
            value={(values.main || {}).attestat_11_issue_date || ''}
            name='attestat_11_issue_date'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='№ приказа'
            value={(values.main || {}).attestat_11_prikaz || ''}
            name='attestat_11_prikaz'
            onChange={handleMainChange}
          />
          <span className={styles.labelText}>от</span>
          <Input
            style={{ width: '150px' }}
            type='date'
            value={(values.main || {}).attestat_11_prikaz_date || ''}
            name='attestat_11_prikaz_date'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Дубликат аттестата 9 класса</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '180px' }}
            label='№ дубликата'
            value={(values.main || {}).attestat_9_dubl_number || ''}
            name='attestat_9_dubl_number'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Дата выдачи'
            type='date'
            value={(values.main || {}).attestat_9_dubl_issue_date || ''}
            name='attestat_9_dubl_issue_date'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='№ приказа'
            value={(values.main || {}).attestat_9_dubl_prikaz || ''}
            name='attestat_9_dubl_prikaz'
            onChange={handleMainChange}
          />
          <span className={styles.labelText}>от</span>
          <Input
            style={{ width: '150px' }}
            type='date'
            value={(values.main || {}).attestat_9_dubl_prikaz_date || ''}
            name='attestat_9_dubl_prikaz_date'
            onChange={handleMainChange}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Дубликат аттестата 11 класса</h3>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '180px' }}
            label='№ дубликата'
            value={(values.main || {}).attestat_11_dubl_number || ''}
            name='attestat_11_dubl_number'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='Дата выдачи'
            type='date'
            value={(values.main || {}).attestat_11_dubl_issue_date || ''}
            name='attestat_11_dubl_issue_date'
            onChange={handleMainChange}
          />
          <Input
            style={{ width: '150px' }}
            label='№ приказа'
            value={(values.main || {}).attestat_11_dubl_prikaz || ''}
            name='attestat_11_dubl_prikaz'
            onChange={handleMainChange}
          />
          <span className={styles.labelText}>от</span>
          <Input
            style={{ width: '150px' }}
            type='date'
            value={(values.main || {}).attestat_11_dubl_prikaz_date || ''}
            name='attestat_11_dubl_prikaz_date'
            onChange={handleMainChange}
          />
        </div>
      </div>
    </div>
  )
}
